export default __webpack_public_path__ + "media/images/dashboard_icons/thankyous-b7dcc6ed4090267468f8247e7ad20216.svg";